import Vue from "vue";

import env from "./env";

export const EventNames = {
  DataRefresh: "refreshData",
  LoggedIn: "loggedIn",
  LoggedOut: "loggedOut"
};

class EventBusImpl extends Vue {
  dataRefreshIntervalId?: number;
}
export const EventBus = new EventBusImpl();

export function StartRefreshInterval(immediateRefresh = false) {
  if (immediateRefresh) {
    EventBus.$emit(EventNames.DataRefresh);
  }

  if (!EventBus.dataRefreshIntervalId) {
    const interval: number = env.dataRefreshIntervalInSeconds * 1000;
    EventBus.dataRefreshIntervalId = setInterval(() => EventBus.$emit(EventNames.DataRefresh), interval);
  }
}

export function StopRefreshInterval() {
  if (EventBus.dataRefreshIntervalId) {
    clearInterval(EventBus.dataRefreshIntervalId);
    EventBus.dataRefreshIntervalId = undefined;
  }
}
